import React, { Component } from 'react';

import { MSection } from 'components/misc';
import {
    Row, Col
} from 'design-react-kit';
import { Helmet } from 'react-helmet';


export class TFAIndire extends Component {

    render() {
        const title = 'Attivati corsi INDIRE -100% online';
        return (
            <>
                <Helmet>
                    <title>{title}</title>
                    <meta property="og:title" content={title} />
                </Helmet>
                {/* <MSection>
                    <Row>
                        <Col>
                            <Title>{title}</Title>
                            <Row>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                    <div className="swiper-slide my-2">
                                        <div className="programme-card">
                                            <a className="programme-card__link" href="../adesioni-tfa-sostegno-estero">
                                                <div className="programme-card__header">
                                                    <img className="programme-card__img" alt="adesioni tfa sostegno estero" src="/img/courses/new/sostegno_estero.jpg" />
                                                </div>
                                                <div className="programme-card__body">
                                                    <h4 className="programme-card__title">Attivati corsi INDIRE - 100% online <br/><span class="small">per tfa sostegno estero</span></h4>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                    <div className="swiper-slide my-2">
                                        <div className="programme-card">
                                            <a className="programme-card__link" href="../adesioni-tfa-sostegno-triennalisti">
                                                <div className="programme-card__header">
                                                    <img className="programme-card__img" alt="adesioni tfa sostegno triennalisti" src="/img/courses/new/sostegno_triennalisti.jpg" />
                                                </div>
                                                <div className="programme-card__body">
                                                    <h4 className="programme-card__title">Attivati corsi INDIRE - 100% online <br/><span class="small">per chi ha tre anni sul sostegno</span></h4>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </MSection> */}
                <MSection>
                    <Row>
                        <Col>
                            <hr />
                            <div class="text-center">
                                <h3>Percorso di Specializzazione Universitaria per le Attività di Sostegno Didattico agli Alunni con Disabilità</h3><hr /></div>
                            <p>
                                Autorizzate dal Ministero le immatricolazioni ai corsi di sostegno 100% online nella scuola dell’infanzia, primaria,
                                I e II grado per chi ha maturato 3 anni di servizio e per chi ha conseguito il titolo estero
                            </p>
                            <h5>Iscrizione Corso di sostegno online al 100% per chi ha maturato 3 anni di servizio</h5>
                            <ul>
                                <li>Scuola Primaria - <a href="/assets/doc/2025-07-09_graduatorie-d.m.-75-2025.pdf" target="_blank">(*) Graduatoria I Edizione</a> - <a href="/assets/doc/DM75_DR 365_Graduatoria-18-07-2025.pdf" target="_blank">(*) Graduatoria II Edizione</a> - <a href="/assets/doc/DM 75_DR 344_Rettificadigraduatorie18-07-2025.pdf" target="_blank">(*) Rettifica Graduatoria I Edizione</a></li>
                                <li>Scuola secondaria di I Grado - <a href="/assets/doc/2025-07-09_graduatorie-d.m.-75-2025.pdf" target="_blank">(*) Graduatoria I Edizione</a> - <a href="/assets/doc/DM 75_DR 344_Rettificadigraduatorie18-07-2025.pdf" target="_blank">(*) Rettifica Graduatoria I Edizione</a> - <a href="/assets/doc/ScorrimentiD.R.344-2025_GRADUATORIE_DM_75-2025 _ 23-07-2025.pdf" target="_blank">(*) Scorrimento Scuola secondaria di I Grado</a></li>
                                <li>Scuola secondaria di II Grado - <a href="/assets/doc/2025-07-09_graduatorie-d.m.-75-2025.pdf" target="_blank">(*) Graduatoria I Edizione</a> - <a href="/assets/doc/DM 75_DR 344_Rettificadigraduatorie18-07-2025.pdf" target="_blank">(*) Rettifica Graduatoria I Edizione</a></li>
                                <li>Scuola dell’Infanzia (a breve le iscrizioni)</li>
                            </ul>
                            <h3>Attenzione: a tutti gli ammessi sono state inviate specifiche comunicazioni riguardo l’immatricolazione.</h3>
                            <hr />
                            <h5>Iscrizione Corso di sostegno online al 100% per chi ha conseguito il titolo estero</h5>
                            <ul>
                                <li>Scuola Primaria (a breve le iscrizioni)</li>
                                <li>Scuola secondaria di I Grado - <a href="/assets/doc/2025-07-09_graduatorie-d.m.-77-2025.pdf" target="_blank">(*) Graduatoria I Edizione</a> - <a href="/assets/doc/DM77_DR 366_Graduatoria-18-07-2025.pdf" target="_blank">(*) Graduatoria II Edizione</a> - <a href="/assets/doc/DM77_DR 346_Scorrimentodigraduatoria18-07-2025.pdf" target="_blank">(*) Scorrimento Graduatoria I Edizione</a></li>
                                <li>Scuola secondaria di II Grado - <a href="/assets/doc/2025-07-09_graduatorie-d.m.-77-2025.pdf" target="_blank">(*) Graduatoria I Edizione</a> - <a href="/assets/doc/DM77_DR 346_Scorrimentodigraduatoria18-07-2025.pdf" target="_blank">(*) Scorrimento Graduatoria I Edizione</a></li>
                                <li>Scuola dell’Infanzia - <a href="/assets/doc/2025-07-09_graduatorie-d.m.-77-2025.pdf" target="_blank">(*) Graduatoria I Edizione</a> - <a href="/assets/doc/DM77_DR 346_Scorrimentodigraduatoria18-07-2025.pdf" target="_blank">(*) Scorrimento Graduatoria I Edizione</a></li>
                            </ul>
                            <h3>Attenzione: a tutti gli ammessi sono state inviate specifiche comunicazioni riguardo l’immatricolazione.</h3>
                            <hr />
                            <p>* Per reperire il codice univoco seguire le indicazioni come da <a href="/assets/doc/guida-id-domanda-dm-75_2025-e-dm-77_2025.pdf" target="_blank">Guida</a></p>
                            <hr />
                            <div class="text-center"><h5>Esami nelle seguenti regioni:</h5></div>
                            <p>Abruzzo, Calabria, Campania, Emilia-Romagna, Friuli Venezia Giulia, Lazio, Liguria, Lombardia, Marche, Piemonte, Puglia, Sardegna, Sicilia, Toscana, Umbria e Veneto.</p>
                        </Col>
                    </Row>
                </MSection >
            </>);
    }
}